import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import axios from 'axios'
import errorJson from './error.json'
const urljoin = require('url-join')
let configUrl = ''
Vue.config.productionTip = false
window.VUE_APP_VERSION = process.env.VUE_APP_VERSION
console.log(process.env.VUE_APP_VERSION) // 输出版本号
// 添加请求拦截器
axios.interceptors.request.use(config => {
  store.state.loading = true
  configUrl = config.url
  config.url = urljoin(process.env.VUE_APP_API_URL, config.url) // 根据环境变量拼接环境
  // 'withCredentials' 表示跨域请求时是否需要使用凭证
  config.withCredentials = true
  return config
}, error => Promise.reject(error)) // 对请求错误做些什么
// 添加响应拦截器
axios.interceptors.response.use(response => {
  store.state.loading = false
  if (response.data.ok) {
    if (configUrl !== '/client/auth') {
      store.dispatch('submitClientAuth')
    }
    return response.data
  }
  const errorMsg = 'code: ' + response.data.error.code + ' msg: ' + errorJson[response.data.error.code]
  if (response.data.error.code === 1000 || response.data.error.code === 1100) {
    store.dispatch('popMessage', {
      text: errorJson[response.data.error.code] === '' ? response.data.error.msg : errorJson[response.data.error.code],
      type: 'confirm',
      click: () => {
        store.state.messageStatus = false
        store.dispatch('signOut')
      }
    })
  } else {
    store.dispatch('popMessage', {
      text: errorJson[response.data.error.code] === '' ? response.data.error.msg : errorJson[response.data.error.code],
      type: 'error'
    }) // 调用自定义提示信息弹窗输出错误信息
  }
  throw new Error(errorMsg)
}, error => Promise.reject(error)) // 对响应错误做些什么

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
